module.exports = __webpack_public_path__ + "static/scale-model-of-arte-américas-in-fresno-california-832815464c273d3cd41878516d19bd89.png";